import httpClient from "../../../../../shared/api/httpClient";
import { qs } from "../../../../../shared/api/qs";

function requireProductionId(productionId) {
  if (!productionId) throw new Error("El ID de la producción es requerido");
}

export function getProductions({
  page = 1,
  limit = 20,
  dateFrom,
  dateTo,
  signal,
} = {}) {
  const query = qs({ page, limit, dateFrom, dateTo });
  return httpClient.get(`/stock/prepared-product-productions${query}`, {
    signal,
  });
}

export function getProduction(productionId, { signal } = {}) {
  requireProductionId(productionId);
  return httpClient.get(
    `/stock/prepared-product-productions/${productionId}`,
    { signal }
  );
}

export function cancelProduction(productionId) {
  requireProductionId(productionId);
  return httpClient.post(
    `/stock/prepared-product-productions/${productionId}/cancel`
  );
}

export function getProductionOptions({ signal } = {}) {
  return httpClient.get("/stock/prepared-product-productions/options", { signal });
}

export function getProductionDirectIngredients(preparedProductId, { signal } = {}) {
  requireProductionId(preparedProductId);
  return httpClient.get(
    `/stock/prepared-product-productions/${preparedProductId}/ingredients`,
    { signal }
  );
}

export function calculateProduction(data, { signal } = {}) {
  return httpClient.post(
    "/stock/prepared-product-productions/calculate",
    data,
    { signal }
  );
}

export function createProduction(data) {
  return httpClient.post("/stock/prepared-product-productions", data);
}
